import { OPEN_CHATPANEL } from '../constants/ActionTypes';

export const openChatPanel = (id, chatType, selectedNumber = null) => ({
  type: OPEN_CHATPANEL,
  id,
  chatType,
  selectedNumber
});
